import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";



const AboutSection = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiRequest({ url: "/about" })
            .then((res) => {
                if (res.success) {
                    setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
                setLoading(false);
            });
    }, []);


    return (
        <div className="container-fluid about py-5">
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    {/* Left Image */}
                    <div className="col-lg-5">
                        <div
                            className="h-100"
                            style={{
                                border: '50px solid',
                                borderColor: 'transparent #3161ab transparent #3161ab',
                            }}
                        >
                            <img
                                src="img/about-img.jpg"
                                className="img-fluid w-100 h-100"
                                alt="About"
                            />
                        </div>
                    </div>

                    <div
                        className="col-lg-7"
                        style={{
                            background: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url(about-img-1.png)`,
                            backgroundSize: 'cover',
                        }}
                    >
                        <h5 className="section-about-title pe-3">About Us</h5>
                        <h1 className="mb-4">
                            Welcome to <span className="text-primary">Holiday Basket Travel and Tourism LLC!</span>
                        </h1>

                        {/* Paragraphs */}
                        <div
                            className="about-description"
                            dangerouslySetInnerHTML={{ __html: data.description }}
                        />

                        <a className="btn btn-primary rounded-pill py-3 px-5 mt-2" href="#">
                            Read More
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutSection;
